import { render, staticRenderFns } from "./RejectInvoiceModal.vue?vue&type=template&id=362bb71b&"
import script from "./RejectInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./RejectInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports